// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d29d158a","455":"01743f3a","977":"2eeafa5f"}[chunkId] + ".chunk.js";
};